var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplePlay = function SvgApplePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.331 2.553.557-.962a1.252 1.252 0 1 1 2.171 1.25l-5.363 9.284h3.879c1.257 0 1.962 1.477 1.415 2.501H1.618c-.694 0-1.25-.556-1.25-1.25s.556-1.25 1.25-1.25h3.188L8.888 5.05 7.613 2.838a1.254 1.254 0 0 1 2.172-1.25l.546.965ZM5.507 15.915 4.305 18a1.252 1.252 0 1 1-2.172-1.25l.894-1.546c1.01-.313 1.83-.073 2.48.71Zm10.356-3.783h3.253c.695 0 1.251.556 1.251 1.25 0 .695-.556 1.251-1.25 1.251h-1.808l1.22 2.117A1.254 1.254 0 0 1 16.358 18c-2.055-3.563-3.598-6.229-4.622-8.005-1.048-1.807-.299-3.622.44-4.237.821 1.41 2.048 3.536 3.687 6.374Z",
    fill: "#fff"
  })));
};
export default SvgApplePlay;